import { isString } from 'es-toolkit';

import { DataDisputeItemStatus, DataDisputeReportInfoFragment } from 'src/api';

export const checkDataDisputeItemStatus = (
  dataDispute: DataDisputeReportInfoFragment,
): DataDisputeItemStatus => {
  return dataDispute.dataDisputeItemsList.every(
    dataDisputeItem => dataDisputeItem.status === DataDisputeItemStatus.Resolved,
  )
    ? DataDisputeItemStatus.Resolved
    : DataDisputeItemStatus.InProgress;
};

export const isDataDisputeItemStatus = (value: unknown): value is DataDisputeItemStatus => {
  return isString(value) && Object.values(DataDisputeItemStatus as object).includes(value);
};
